import { useCallback, useEffect, useRef, useState } from 'react';
import { cognitionApi } from '../services/cognitionApi';

export function useAssessmentBattery() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Only the most recent request may write state — `reload` can be pressed
  // while the previous request is still in flight, and the loser of that race
  // must not overwrite the winner's result. Same guard as useGScoreHistory.
  const requestIdRef = useRef(0);

  const load = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    const current = () => requestId === requestIdRef.current;
    setLoading(true);
    setError(null);
    try {
      const res = await cognitionApi.fetchAssessmentBattery();
      if (!current()) return;
      setData(res);
    } catch (e) {
      if (!current()) return;
      if (process.env.NODE_ENV !== 'production') {
        console.error('[useAssessmentBattery] load error:', e);
      }
      setError('Something went wrong loading your assessment. Please try again.');
    } finally {
      if (current()) setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    return () => {
      requestIdRef.current += 1;
    };
  }, [load]);

  return { data, loading, error, reload: load };
}
